import { httpClient } from '@/configs/axios.config'
import type {
  ViewListItem,
  View,
  CreateView,
  UpdateView,
  ViewEntityType,
} from '@/types/api'

interface ViewListResponse {
  data: ViewListItem[]
}

/**
 * Fetch all views for an entity type (own + shared)
 */
export async function getViews(
  entityType: ViewEntityType
): Promise<ViewListItem[]> {
  const response = await httpClient.get<ViewListResponse>('/views', {
    params: { entityType },
  })
  return response.data.data
}

/**
 * Get a single view by ID with columns, filters, sorts
 */
export async function getView(id: string): Promise<View> {
  const response = await httpClient.get<View>(`/views/${id}`)
  return response.data
}

/**
 * Create a new view
 */
export async function createView(data: CreateView): Promise<View> {
  const response = await httpClient.post<View>('/views', data)
  return response.data
}

/**
 * Update an existing view (owner only)
 */
export async function updateView(id: string, data: UpdateView): Promise<View> {
  const response = await httpClient.patch<View>(`/views/${id}`, data)
  return response.data
}

/**
 * Delete a view (owner only)
 */
export async function deleteView(id: string): Promise<void> {
  await httpClient.delete(`/views/${id}`)
}

/**
 * Duplicate a view (creates personal copy)
 */
export async function duplicateView(id: string, name: string): Promise<View> {
  const response = await httpClient.post<View>(`/views/${id}/duplicate`, {
    name,
  })
  return response.data
}
